import { ActionPayloadType } from '../types';

function togglePreventExit({ commit }: ActionPayloadType, prevent_exit?: boolean) {
  commit('togglePreventExit', prevent_exit);
}

export default {
  togglePreventExit,
};
